
import React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import CustomPaginationActionsTable from '../ApproveConsum/ConsApproveTable';
import ConsPreviewEdit from './ConsPreviewEdit'

const Container = styled.div``

const ConsumableApprove = () => {
   
  const [id, setId] = useState('');
  const [changePage, setChangePage] = useState([true, false])

  const handlePreview = (e, id) => {
    setChangePage([false, true])
    setId(id)
  }

  return (
    <Container>
      {changePage[1] &&<ConsPreviewEdit reqid={id} setChangePage={setChangePage}/>}
      {changePage[0] &&<CustomPaginationActionsTable handlePreview={handlePreview} />}
    </Container>
  )
}

export default ConsumableApprove;